import { useAuth } from '@/containers'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { type Dispatch, type SetStateAction } from 'react'

interface BadgeProps {
  children: React.ReactNode
  title: string
  hasButton?: boolean
  cancelButton?: boolean
  id?: string
  type?: string
  className?: string
  classNameTitle?: string
  orderId?: string
  handleButtonClick?: Dispatch<SetStateAction<boolean>>
}

const Badge = ({
  children,
  title,
  id,
  type = '',
  hasButton = false,
  cancelButton = false,
  className = '',
  classNameTitle = '',
  orderId = '',
  handleButtonClick = () => true,
}: BadgeProps) => {
  const t = useTranslations('CheckoutPayment')
  const { user } = useAuth()
  return (
    <div
      className={`${className} mb-3 rounded border border-grey px-[24px] pb-3`}
      id={id}
    >
      <div
        className={` ${classNameTitle} relative mx-[-24px] rounded-t-[4px] border-b bg-grey-200 px-[24px] py-[15px] text-percent`}
      >
        <span className='font-bold'>{title}</span>
        {hasButton &&
          (user && (type === 'cart' || type === 'installment') ? (
            <div className='orderButtons absolute right-4 top-[50%] translate-y-[-50%]'>
              <button
                className='text-Label text-blue'
                onClick={() => handleButtonClick(prev => !prev)}
              >
                Chọn địa chỉ
              </button>
            </div>
          ) : (
            <div className='orderButtons'>
              <Link
                className={`text-Label text-blue ${
                  cancelButton
                    ? 'mr-[15px] border-r border-grey-400 pr-[15px]'
                    : ''
                }`}
                href={user ? '/orders/' + orderId : '/search-order'}
              >
                {t('manageOrder')}
              </Link>
              {cancelButton && (
                <button
                  className='text-r200 inline-flex text-Label'
                  onClick={() => handleButtonClick(prev => !prev)}
                >
                  {t('cancel')}
                </button>
              )}
            </div>
          ))}
      </div>
      {children}
    </div>
  )
}
export default Badge
